import React from 'react';
import ReactPaginate from 'react-paginate';

interface PaginationProps {
  pageCount: number;
  onPageChange: ({ selected }: { selected: number }) => void;
  currentPage?: number;
  marginPagesDisplayed?: number;
  pageRangeDisplayed?: number;
  className?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  pageCount,
  onPageChange,
  currentPage = 1,
  marginPagesDisplayed = 2,
  pageRangeDisplayed = 2,
  className = "",
}) => {
  if (pageCount <= 1) return null;

  return (
    <div className={`flex justify-center mt-8 ${className}`}>
      <ReactPaginate
        previousLabel={
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        }
        nextLabel={
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        }
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={marginPagesDisplayed}
        pageRangeDisplayed={pageRangeDisplayed}
        onPageChange={onPageChange}
        forcePage={currentPage - 1}
        containerClassName="flex items-center justify-center gap-2"
        pageClassName=""
        pageLinkClassName="flex items-center justify-center w-10 h-10 rounded-full border border-pink-300 text-pink-600 hover:bg-pink-50 hover:border-pink-400 transition-all duration-200 cursor-pointer text-sm font-medium"
        activeClassName=""
        activeLinkClassName="bg-[pink] border-[pink] text-white hover:bg-pink-600 hover:border-pink-600"
        previousClassName=""
        previousLinkClassName="flex items-center justify-center w-10 h-10 rounded-full border border-pink-300 text-pink-600 hover:bg-pink-50 hover:border-pink-400 transition-all duration-200 cursor-pointer"
        nextClassName=""
        nextLinkClassName="flex items-center justify-center w-10 h-10 rounded-full border border-pink-300 text-pink-600 hover:bg-pink-50 hover:border-pink-400 transition-all duration-200 cursor-pointer"
        breakClassName=""
        breakLinkClassName="flex items-center justify-center w-10 h-10 text-gray-500 text-sm"
        disabledClassName="opacity-50 cursor-not-allowed"
        disabledLinkClassName="opacity-50 cursor-not-allowed hover:bg-transparent hover:border-gray-300"
      />
    </div>
  );
};

export default Pagination;
